import { render, staticRenderFns } from "./VideoLink.vue?vue&type=template&id=3ae25ebc&scoped=true&"
import script from "./VideoLink.vue?vue&type=script&lang=ts&"
export * from "./VideoLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae25ebc",
  null
  
)

export default component.exports